module.exports = __webpack_public_path__ + "media/images/expand-a797b71e4eaf3d35121bcbfafb704d99.png";